const displayFallbackImage = (wrapper, video) => {
    // Auto-play was prevented, relevant for older Safaris
    const fallbackImg = wrapper.querySelector('.js-mscr-html__fallback');
    wrapper.appendChild(fallbackImg);
    wrapper.removeChild(video);
}

const handleIE = (wrapper) => {
    const isIE11 = /Trident.*rv[ :]*11\./.test(navigator.userAgent);
    const video = wrapper.querySelector('video');

    if (isIE11) {
        displayFallbackImage(wrapper, video);
    }
}

const initHtmlVideo = () => {
    const playerWrappers = document.querySelectorAll('.js-mscr-html__wrapper');
    for (let i = 0; i < playerWrappers.length; i++) {
        handleIE(playerWrappers[i]);

        const sources = playerWrappers[i].querySelectorAll('source');
        let source_errors = 0;
        for (let j = 0; j < sources.length; j++) {
            sources[j].addEventListener('error', function(ev) {
                if (++source_errors >= sources.length)
                displayFallbackImage(playerWrappers[i], ev.target.parentNode);
            });
        }
    }
}

document.addEventListener('DOMContentLoaded', initHtmlVideo);
